"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7607],{

/***/ 7607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Offers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7311);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4250);
/* eslint-disable react/no-danger */ 



function Offers(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, mainDiv = ref.main_div, appData = ref.appData, apiUrl = ref.apiUrl, _devId = ref.devId, devId = _devId === void 0 ? "" : _devId, _mcid = ref.mcid, mcid = _mcid === void 0 ? "" : _mcid, ccde = ref.ccde, state = ref.state, _appConfig = ref.appConfig, appConfig = _appConfig === void 0 ? {} : _appConfig, lang = ref.lang, device = ref.device, headingAndSearchBar = ref.heading_and_searchbar, intid = ref.intid, contentTop = ref.contentTop, contentMiddle = ref.contentMiddle, contentBottom = ref.contentBottom, bottomBlock = ref.bottomBlock, topOverlay = ref.top_overlay, initialJS = ref.initial_js, tokenJson = ref.tokenJson, templateType = ref.template_type;
    var isDesktop = device === "desktop";
    var isLive = appConfig.liveMode;
    var srcWidget = "";
    if (isLive) {
        if (isDesktop) {
            srcWidget = lang === "hin" ? "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidget.min.js" : "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidget.min.js";
        } else {
            srcWidget = lang === "hin" ? "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/hiStaticSeoWidgetMob.min.js" : "https://jsak.mmtcdn.com/flights-cms-seo/assets/_next/static/js/staticSeoWidgetMob.min.js";
        }
    } else if (isDesktop) {
        srcWidget = lang === "hin" ? "http://localhost:3000/_next/static/js/hiStaticSeoWidget.min.js" : "http://localhost:3000/_next/static/js/staticSeoWidget.min.js";
    } else {
        srcWidget = lang === "hin" ? "http://localhost:3000/_next/static/js/hiStaticSeoWidgetMob.min.js" : "http://localhost:3000/_next/static/js/staticSeoWidgetMob.min.js";
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var bodyElement = document.body;
        bodyElement.id = "cmsintlflt";
        bodyElement.className = "bodyClass";
        bodyElement.setAttribute("data-domain", "www_intl_flight_makemytrip_com");
    }, []);
    var scriptTransform = {
        transform: function(node) {
            if (node.type === "script") {
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    defer: true,
                    src: node === null || node === void 0 ? void 0 : (ref = node.attribs) === null || ref === void 0 ? void 0 : ref.src,
                    children: (ref1 = node === null || node === void 0 ? void 0 : node.children[0]) === null || ref1 === void 0 ? void 0 : ref1.data
                });
            }
            return null;
        }
    };
    var stylesDesktop = ".midContainerSpace{\n    height: 0 !important;\n}\n.midContainer {\nwidth: 100%;\npadding: 20px 0;\nmargin-top: -20px;\n}\n@media screen and (min-width: 768px) {\n    .fli-intl-container {\n        padding-top: 0;\n    }\n}\n.lockPriceModalWrapper .arrow::after, .arrow::before {\n    height: 0px !important;\n}\n.widgetSprite {\n    background-position: -5px -5px !important;\n}\n.container {\nmargin-top: 15px;\nwidth: 100%;\n}\n.modify-search-header{\ndisplay: none !important;\n}";
    var stylesMobile = ".modify-search-header {\n    position: relative !important;\n    font-family: Lato-Regular,Arial,Helvetica,sans-serif !important;\n}\n.midContainer {\n    padding: 0 !important;\n    margin-top: -10px !important;\n}\n.widgetSprite {\n    background-position: -5px -5px !important;\n}\n.lndngFltPrgsvWrap--hdr span h1 {\n    font-size: 25px !important;\n}\n.srchForm {\n    box-shadow: none;\n}\n.container {\nmargin-top: 15px;\n/* width: 100%; */\n}";
    tokenJson.currentTemplate = templateType;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n          window.FLTS = {};\n          window.FLTS.listingStartTime = Date.now();\n          window.page = "offers";\n          window.countryCode = \''.concat(ccde, "';\n          window.lang = '").concat(lang, "';\n          window.url ='").concat(apiUrl, "';\n          window.devId = \"").concat(devId || "", '";\n          window.mcid = "').concat(mcid || "", '";\n          window.appData = ').concat(JSON.stringify(appData), ";")
                },
                type: "text/javascript"
            }),
            initialJS && initialJS !== "" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(initialJS) : null,
            isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: stylesDesktop
                }
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: stylesMobile
                }
            }),
            isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "newSection modify-search-header",
                id: "orderHeader",
                children: (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(headingAndSearchBar)
            }) : // <header className="modify-search-header" id="orderHeader">
            //   { transformToHtml(headingAndSearchBar) }
            // </header>
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                dangerouslySetInnerHTML: {
                    __html: headingAndSearchBar
                },
                className: "modify-search-header",
                id: "orderHeader"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "midContainer",
                children: [
                    (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(contentTop),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: mainDiv
                        }
                    }),
                    (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(contentMiddle),
                    contentBottom && bottomBlock && bottomBlock.length > 0 && contentBottom.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "container offersWrapper",
                        children: [
                            (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(contentBottom),
                            (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(bottomBlock)
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                ]
            }),
            (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .transformToHtml */ .cR)(topOverlay),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "window.showLeaveIntent = true;"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n      var tokenJson = ".concat(tokenJson ? JSON.stringify(tokenJson) : '{"dest_city_name":"Mumbai","src_city_code":"DEL","dest_city_code":"BOM","src_city_name":"New Delhi"};', '\n      var intid = "').concat(intid, '";\n      var mmt = window.mmt || {};\n      mmt.hlp = mmt.hlp || {};\n      var device = "').concat(device, "\";\n      var pageType = 'home', WEBSITE_URL = '//www.makemytrip.com', funnel_URL = '', mouseRecorder = '', serverTodayDate = ").concat(JSON.stringify(new Date()), ", serverTime = ").concat(JSON.stringify(new Date()), ", noOfDaysToAddInDept = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInDept) || "", ", noOfDaysToAddInReturn = ").concat((tokenJson === null || tokenJson === void 0 ? void 0 : tokenJson.noOfDaysToAddInReturn) || "", "\n      ")
                },
                type: "text/javascript"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "overlay_hamburger"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                id: "back-top",
                className: "back-to-top",
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                defer: true,
                type: "text/javascript",
                src: "".concat(srcWidget)
            })
        ]
    });
}


/***/ })

}]);